import { Link, Navigate, useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import { useEvents } from '../lib/hooks';
import { LOGO_SRC } from '../components/ui';
import { EmailCode } from '../components/EmailCode';
import { GoogleSignIn, useGoogleEnabled } from '../components/GoogleSignIn';
import { DemoLogins } from '../components/demo';

export default function SignIn() {
  const { session, ready } = useAuth();
  const { live } = useEvents();
  const google = useGoogleEnabled().data;
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const next = params.get('next') || '/';

  if (ready && session) return <Navigate to={next} replace />;

  return (
    <div className="shell">
      <EmailCode
        head={(
          <>
            <span className="brand-chip"><img src={LOGO_SRC} alt="ONE10" style={{ height: 40 }} /></span>
            <p className="app-eyebrow">{live.length ? `${live.map((e) => e.name).join(' · ')} · ` : ''}Food</p>
            <h1>Sign in to ONE10 Food Pass</h1>
            <p className="muted">{google ? 'With Google in one tap, or with your email: we email you a 6-digit code.'
              : "Use your email. We'll email you a 6-digit code."} There's no password.</p>
            <DemoLogins />
          </>
        )}
        alt={<GoogleSignIn next={next} />}
        onSignedIn={() => navigate(next, { replace: true })}
        footer={(
          <div className="stack" style={{ gap: 6 }}>
            {next === '/' && <Link className="btn ghost block" to="/">See what's on and the meals first</Link>}
            <p className="fine">Food Committee and help desk volunteers sign in here too, with the email the committee added.</p>
          </div>
        )}
      />
    </div>
  );
}
